/*
 *
 * AttendanceControl reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_ATTENDANCECONTROL,
  LOAD_ATTENDANCECONTROL,
  LOAD_ATTENDANCECONTROL_SUCCESS,
  LOAD_ATTENDANCECONTROL_ERROR,
  CHANGE_ATTENDANCECONTROL,
  CHANGE_ATTENDANCECONTROL_SUCCESS,
  CHANGE_ATTENDANCECONTROL_ERROR,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  loadingCnahge: false,
  error: false,
  errorChange: false,
  deleteSuccessful: false,
  attendanceData: false,
  id: false,
  // course
  courseID: null,
  onDate: null,
  timeZone: null,
  onDateAbsences: null,
  onDateAttendances: null,
  courseDetail: null,
  courseLoading: false,
  courseError: false,
  isTeacher: false,
};

/* eslint-disable default-case, no-param-reassign */
const attendanceControlReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ATTENDANCECONTROL:
        return initialState;

      // LOAD
      case LOAD_ATTENDANCECONTROL:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_ATTENDANCECONTROL_SUCCESS:
        draft.attendanceData = action.attendanceData;
        draft.loading = false;
        break;

      case LOAD_ATTENDANCECONTROL_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_ATTENDANCECONTROL:
        draft.attendanceData = {
          ...state.attendanceData,
          ...action.attendanceData,
        };
        draft.timeZone = action.timeZone;
        draft.loadingCnahge = true;
        draft.errorChange = false;
        break;

      case CHANGE_ATTENDANCECONTROL_SUCCESS:
        draft.attendanceData = action.attendanceData;
        draft.loadingCnahge = false;

        break;

      case CHANGE_ATTENDANCECONTROL_ERROR:
        draft.errorChange = action.errorChange;
        draft.loadingCnahge = false;
        break;
      
      case LOAD_COURSE:
        draft.courseLoading = true;
        draft.courseError = false;
        draft.courseID = action.courseID;
        draft.onDate = action.onDate;
        draft.timeZone = action.timeZone;
        break;

      case LOAD_COURSE_SUCCESS:
        draft.courseLoading = false;
        draft.isTeacher = action.isTeacher;
        if (!!action.isTeacher) {
          draft.courseDetail = action.courseDetail?.course;
          draft.onDateAbsences = action.courseDetail?.absences;
          draft.onDateAttendances = action.courseDetail?.attendances;
        } else {
          draft.courseDetail = action.courseDetail;
        }
      
        break;

      case LOAD_COURSE_ERROR:
        draft.courseError = action.courseError;
        draft.courseLoading = false;
        draft.courseDetail = false;
        break;
    }
  });

export default attendanceControlReducer;
